const ChevronToggleIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12.707" height="17.414" viewBox="0 0 12.707 17.414">
            <g id="Group_8382" data-name="Group 8382" transform="translate(-1414.146 -1531.793)">
                <path
                    id="Path_3581"
                    data-name="Path 3581"
                    d="M5271.342,2230l6,6,6-6"
                    transform="translate(-3856.842 -687.5)"
                    fill="none"
                    stroke="#1650b4"
                    strokeWidth="1"
                />
                <path
                    id="Path_3582"
                    data-name="Path 3582"
                    d="M5271.342,2230l6,6,6-6"
                    transform="translate(6697.842 3768.5) rotate(-180)"
                    fill="none"
                    stroke="#1650b4"
                    strokeWidth="1"
                />
            </g>
        </svg>
    );
};

export default ChevronToggleIcon;
